const enumLabels = {
  de: {
    priorities: { LOW: 'Niedrig', MEDIUM: 'Mittel', HIGH: 'Hoch', CRITICAL: 'Kritisch' },
    recommendationStatuses: {
      OPEN: 'Offen',
      IN_PROGRESS: 'In Bearbeitung',
      SNOOZED: 'Zurückgestellt',
      COMPLETED: 'Erledigt',
      STALE: 'Nicht mehr aktuell',
      IRRELEVANT: 'Nicht relevant',
      EXCLUDED: 'Dauerhaft ausgeschlossen',
    },
    taskStatuses: {
      OPEN: 'Offen',
      IN_PROGRESS: 'In Bearbeitung',
      WAITING: 'Wartet',
      COMPLETED: 'Erledigt',
      CANCELLED: 'Abgebrochen',
    },
    taskActivities: {
      CALL: 'Anruf',
      CALLBACK: 'Rückruf',
      VISIT: 'Außendienstbesuch',
      MEETING: 'Termin',
      EMAIL: 'E-Mail',
      QUOTE: 'Angebot',
      FOLLOW_UP: 'Wiedervorlage',
      COMPLAINT: 'Reklamation',
      OTHER: 'Sonstige Aufgabe',
    },
  },
  en: {
    priorities: { LOW: 'Low', MEDIUM: 'Medium', HIGH: 'High', CRITICAL: 'Critical' },
    recommendationStatuses: {
      OPEN: 'Open',
      IN_PROGRESS: 'In progress',
      SNOOZED: 'Snoozed',
      COMPLETED: 'Completed',
      STALE: 'No longer current',
      IRRELEVANT: 'Not relevant',
      EXCLUDED: 'Permanently excluded',
    },
    taskStatuses: {
      OPEN: 'Open',
      IN_PROGRESS: 'In progress',
      WAITING: 'Waiting',
      COMPLETED: 'Completed',
      CANCELLED: 'Cancelled',
    },
    taskActivities: {
      CALL: 'Call',
      CALLBACK: 'Callback',
      VISIT: 'Field visit',
      MEETING: 'Meeting',
      EMAIL: 'Email',
      QUOTE: 'Quote',
      FOLLOW_UP: 'Follow-up',
      COMPLAINT: 'Complaint',
      OTHER: 'Other task',
    },
  },
  tr: {
    priorities: { LOW: 'Düşük', MEDIUM: 'Orta', HIGH: 'Yüksek', CRITICAL: 'Kritik' },
    recommendationStatuses: {
      OPEN: 'Açık',
      IN_PROGRESS: 'İşleniyor',
      SNOOZED: 'Ertelendi',
      COMPLETED: 'Tamamlandı',
      STALE: 'Artık güncel değil',
      IRRELEVANT: 'İlgili değil',
      EXCLUDED: 'Kalıcı olarak hariç',
    },
    taskStatuses: {
      OPEN: 'Açık',
      IN_PROGRESS: 'İşleniyor',
      WAITING: 'Bekliyor',
      COMPLETED: 'Tamamlandı',
      CANCELLED: 'İptal edildi',
    },
    taskActivities: {
      CALL: 'Arama',
      CALLBACK: 'Geri arama',
      VISIT: 'Saha ziyareti',
      MEETING: 'Toplantı',
      EMAIL: 'E-posta',
      QUOTE: 'Teklif',
      FOLLOW_UP: 'Takip',
      COMPLAINT: 'Şikâyet',
      OTHER: 'Diğer görev',
    },
  },
  fr: {
    priorities: { LOW: 'Faible', MEDIUM: 'Moyenne', HIGH: 'Haute', CRITICAL: 'Critique' },
    recommendationStatuses: {
      OPEN: 'Ouverte',
      IN_PROGRESS: 'En cours',
      SNOOZED: 'Reportée',
      COMPLETED: 'Terminée',
      STALE: 'Plus actuelle',
      IRRELEVANT: 'Non pertinente',
      EXCLUDED: 'Exclue définitivement',
    },
    taskStatuses: {
      OPEN: 'Ouverte',
      IN_PROGRESS: 'En cours',
      WAITING: 'En attente',
      COMPLETED: 'Terminée',
      CANCELLED: 'Annulée',
    },
    taskActivities: {
      CALL: 'Appel',
      CALLBACK: 'Rappel',
      VISIT: 'Visite terrain',
      MEETING: 'Rendez-vous',
      EMAIL: 'E-mail',
      QUOTE: 'Devis',
      FOLLOW_UP: 'Suivi',
      COMPLAINT: 'Réclamation',
      OTHER: 'Autre tâche',
    },
  },
  es: {
    priorities: { LOW: 'Baja', MEDIUM: 'Media', HIGH: 'Alta', CRITICAL: 'Crítica' },
    recommendationStatuses: {
      OPEN: 'Abierta',
      IN_PROGRESS: 'En curso',
      SNOOZED: 'Pospuesta',
      COMPLETED: 'Completada',
      STALE: 'Ya no vigente',
      IRRELEVANT: 'No relevante',
      EXCLUDED: 'Excluida permanentemente',
    },
    taskStatuses: {
      OPEN: 'Abierta',
      IN_PROGRESS: 'En curso',
      WAITING: 'En espera',
      COMPLETED: 'Completada',
      CANCELLED: 'Cancelada',
    },
    taskActivities: {
      CALL: 'Llamada',
      CALLBACK: 'Devolución de llamada',
      VISIT: 'Visita comercial',
      MEETING: 'Reunión',
      EMAIL: 'Correo',
      QUOTE: 'Oferta',
      FOLLOW_UP: 'Seguimiento',
      COMPLAINT: 'Reclamación',
      OTHER: 'Otra tarea',
    },
  },
  ru: {
    priorities: { LOW: 'Низкий', MEDIUM: 'Средний', HIGH: 'Высокий', CRITICAL: 'Критический' },
    recommendationStatuses: {
      OPEN: 'Открыта',
      IN_PROGRESS: 'В работе',
      SNOOZED: 'Отложена',
      COMPLETED: 'Завершена',
      STALE: 'Больше не актуальна',
      IRRELEVANT: 'Неактуальна',
      EXCLUDED: 'Исключена навсегда',
    },
    taskStatuses: {
      OPEN: 'Открыта',
      IN_PROGRESS: 'В работе',
      WAITING: 'Ожидает',
      COMPLETED: 'Завершена',
      CANCELLED: 'Отменена',
    },
    taskActivities: {
      CALL: 'Звонок',
      CALLBACK: 'Обратный звонок',
      VISIT: 'Выезд',
      MEETING: 'Встреча',
      EMAIL: 'Эл. почта',
      QUOTE: 'Предложение',
      FOLLOW_UP: 'Повторный контакт',
      COMPLAINT: 'Претензия',
      OTHER: 'Другая задача',
    },
  },
} as const;

const ruleTypes = {
  de: {
    LAST_ORDER_UNUSUAL: 'Letzte Bestellung ungewöhnlich lange her',
    PERSONAL_CONTACT_OVERDUE: 'Persönlicher Kontakt überfällig',
    EXPECTED_REORDER_MISSED: 'Erwartete Folgebestellung ausgeblieben',
    NEW_CUSTOMER_NO_SECOND_ORDER: 'Neukunde ohne zweite Bestellung',
    PROSPECT_FOLLOW_UP_OVERDUE: 'Interessent ohne Nachverfolgung',
    QUOTE_WITHOUT_RESPONSE: 'Angebot ohne Reaktion',
    REVENUE_DECLINE: 'Umsatzrückgang',
    ORDER_FREQUENCY_DECLINE: 'Bestellhäufigkeit gesunken',
    REGULAR_PRODUCT_MISSING: 'Stammartikel fehlt',
    PRODUCT_CATEGORY_MISSING: 'Typische Warengruppe fehlt',
    PORTAL_CART_ABANDONED: 'Portal-Warenkorb nicht abgeschlossen',
    CALLBACK_WITHOUT_TASK: 'Rückrufwunsch ohne Aufgabe',
    CUSTOMER_UNASSIGNED: 'Vertriebsverantwortlicher fehlt',
    COMMERCIAL_VALIDITY_EXPIRING: 'Gültigkeit läuft ab',
    OPEN_COMPLAINT_OR_RETURN: 'Offene Reklamation oder Retoure',
    CUSTOMER_BLOCKED_OR_AT_RISK: 'Sperre oder Risiko',
    OVERDUE_INVOICE_OR_DUNNING: 'Überfällige Zahlung',
  },
  en: {
    LAST_ORDER_UNUSUAL: 'Last order unusually long ago',
    PERSONAL_CONTACT_OVERDUE: 'Personal contact overdue',
    EXPECTED_REORDER_MISSED: 'Expected reorder missed',
    NEW_CUSTOMER_NO_SECOND_ORDER: 'New customer without second order',
    PROSPECT_FOLLOW_UP_OVERDUE: 'Prospect without follow-up',
    QUOTE_WITHOUT_RESPONSE: 'Quote without response',
    REVENUE_DECLINE: 'Revenue decline',
    ORDER_FREQUENCY_DECLINE: 'Order frequency declined',
    REGULAR_PRODUCT_MISSING: 'Regular product missing',
    PRODUCT_CATEGORY_MISSING: 'Typical product category missing',
    PORTAL_CART_ABANDONED: 'Portal cart not completed',
    CALLBACK_WITHOUT_TASK: 'Callback request without task',
    CUSTOMER_UNASSIGNED: 'Sales owner missing',
    COMMERCIAL_VALIDITY_EXPIRING: 'Commercial validity expiring',
    OPEN_COMPLAINT_OR_RETURN: 'Open complaint or return',
    CUSTOMER_BLOCKED_OR_AT_RISK: 'Block or risk',
    OVERDUE_INVOICE_OR_DUNNING: 'Overdue payment',
  },
  tr: {
    LAST_ORDER_UNUSUAL: 'Son sipariş alışılmadık kadar eski',
    PERSONAL_CONTACT_OVERDUE: 'Kişisel iletişim gecikti',
    EXPECTED_REORDER_MISSED: 'Beklenen tekrar sipariş gelmedi',
    NEW_CUSTOMER_NO_SECOND_ORDER: 'İkinci siparişi olmayan yeni müşteri',
    PROSPECT_FOLLOW_UP_OVERDUE: 'Takipsiz potansiyel müşteri',
    QUOTE_WITHOUT_RESPONSE: 'Yanıtsız teklif',
    REVENUE_DECLINE: 'Ciro düşüşü',
    ORDER_FREQUENCY_DECLINE: 'Sipariş sıklığı düştü',
    REGULAR_PRODUCT_MISSING: 'Düzenli ürün eksik',
    PRODUCT_CATEGORY_MISSING: 'Tipik ürün grubu eksik',
    PORTAL_CART_ABANDONED: 'Portal sepeti tamamlanmadı',
    CALLBACK_WITHOUT_TASK: 'Görevsiz geri arama isteği',
    CUSTOMER_UNASSIGNED: 'Satış sorumlusu eksik',
    COMMERCIAL_VALIDITY_EXPIRING: 'Ticari geçerlilik sona eriyor',
    OPEN_COMPLAINT_OR_RETURN: 'Açık şikâyet veya iade',
    CUSTOMER_BLOCKED_OR_AT_RISK: 'Bloke veya risk',
    OVERDUE_INVOICE_OR_DUNNING: 'Gecikmiş ödeme',
  },
  fr: {
    LAST_ORDER_UNUSUAL: 'Dernière commande inhabituellement ancienne',
    PERSONAL_CONTACT_OVERDUE: 'Contact personnel en retard',
    EXPECTED_REORDER_MISSED: 'Renouvellement attendu manqué',
    NEW_CUSTOMER_NO_SECOND_ORDER: 'Nouveau client sans deuxième commande',
    PROSPECT_FOLLOW_UP_OVERDUE: 'Prospect sans suivi',
    QUOTE_WITHOUT_RESPONSE: 'Devis sans réponse',
    REVENUE_DECLINE: 'Baisse du chiffre d’affaires',
    ORDER_FREQUENCY_DECLINE: 'Fréquence de commande en baisse',
    REGULAR_PRODUCT_MISSING: 'Produit habituel absent',
    PRODUCT_CATEGORY_MISSING: 'Catégorie habituelle absente',
    PORTAL_CART_ABANDONED: 'Panier du portail non finalisé',
    CALLBACK_WITHOUT_TASK: 'Demande de rappel sans tâche',
    CUSTOMER_UNASSIGNED: 'Responsable commercial manquant',
    COMMERCIAL_VALIDITY_EXPIRING: 'Validité commerciale proche de l’échéance',
    OPEN_COMPLAINT_OR_RETURN: 'Réclamation ou retour ouvert',
    CUSTOMER_BLOCKED_OR_AT_RISK: 'Blocage ou risque',
    OVERDUE_INVOICE_OR_DUNNING: 'Paiement en retard',
  },
  es: {
    LAST_ORDER_UNUSUAL: 'Último pedido inusualmente antiguo',
    PERSONAL_CONTACT_OVERDUE: 'Contacto personal vencido',
    EXPECTED_REORDER_MISSED: 'Reposición prevista ausente',
    NEW_CUSTOMER_NO_SECOND_ORDER: 'Cliente nuevo sin segundo pedido',
    PROSPECT_FOLLOW_UP_OVERDUE: 'Cliente potencial sin seguimiento',
    QUOTE_WITHOUT_RESPONSE: 'Oferta sin respuesta',
    REVENUE_DECLINE: 'Descenso de ingresos',
    ORDER_FREQUENCY_DECLINE: 'Frecuencia de pedidos reducida',
    REGULAR_PRODUCT_MISSING: 'Falta un producto habitual',
    PRODUCT_CATEGORY_MISSING: 'Falta una categoría habitual',
    PORTAL_CART_ABANDONED: 'Carrito del portal sin completar',
    CALLBACK_WITHOUT_TASK: 'Solicitud de llamada sin tarea',
    CUSTOMER_UNASSIGNED: 'Falta responsable comercial',
    COMMERCIAL_VALIDITY_EXPIRING: 'Validez comercial próxima a vencer',
    OPEN_COMPLAINT_OR_RETURN: 'Reclamación o devolución abierta',
    CUSTOMER_BLOCKED_OR_AT_RISK: 'Bloqueo o riesgo',
    OVERDUE_INVOICE_OR_DUNNING: 'Pago vencido',
  },
  ru: {
    LAST_ORDER_UNUSUAL: 'Последний заказ был необычно давно',
    PERSONAL_CONTACT_OVERDUE: 'Личный контакт просрочен',
    EXPECTED_REORDER_MISSED: 'Ожидаемый повторный заказ не поступил',
    NEW_CUSTOMER_NO_SECOND_ORDER: 'Новый клиент без второго заказа',
    PROSPECT_FOLLOW_UP_OVERDUE: 'Потенциальный клиент без продолжения',
    QUOTE_WITHOUT_RESPONSE: 'Предложение без ответа',
    REVENUE_DECLINE: 'Снижение выручки',
    ORDER_FREQUENCY_DECLINE: 'Частота заказов снизилась',
    REGULAR_PRODUCT_MISSING: 'Нет регулярно заказываемого товара',
    PRODUCT_CATEGORY_MISSING: 'Нет обычной товарной группы',
    PORTAL_CART_ABANDONED: 'Корзина портала не оформлена',
    CALLBACK_WITHOUT_TASK: 'Просьба перезвонить без задачи',
    CUSTOMER_UNASSIGNED: 'Не назначен менеджер',
    COMMERCIAL_VALIDITY_EXPIRING: 'Срок коммерческих условий истекает',
    OPEN_COMPLAINT_OR_RETURN: 'Открытая претензия или возврат',
    CUSTOMER_BLOCKED_OR_AT_RISK: 'Блокировка или риск',
    OVERDUE_INVOICE_OR_DUNNING: 'Просроченный платёж',
  },
} as const;

const base = {
  de: {
    title: 'Vertriebsassistent',
    subtitle:
      'Nachvollziehbare Kundenpflege, konkrete Aufgaben und keine versteckte Leistungsüberwachung.',
    recommendations: 'Empfehlungen',
    tasks: 'Aufgaben',
    myWork: 'Meine Aufgaben',
    team: 'Teamansicht',
    allAccess: 'Alle freigegebenen Vorgänge',
    search: 'Kunden, Nummern und Hinweise durchsuchen',
    searchPlaceholder: 'Kunde oder Kundennummer suchen …',
    cards: 'Kartenansicht',
    list: 'Listenansicht',
    filters: 'Filter',
    sort: 'Sortierung',
    allPriorities: 'Alle Prioritäten',
    sortOptions: {
      priority: 'Priorität und Fälligkeit',
      dueAsc: 'Fälligkeit aufsteigend',
      dueDesc: 'Fälligkeit absteigend',
      newest: 'Neueste zuerst',
    },
    summary: {
      dueNow: 'Jetzt fällige Kontakte',
      overdueTasks: 'Überfällige Aufgaben',
      todayCalls: 'Heute geplante Anrufe',
      upcomingFollowUps: 'Bevorstehende Wiedervorlagen',
      missedReorders: 'Ausgebliebene Bestellungen',
      revenueDeclines: 'Umsatzrückgänge',
      openQuotes: 'Offene Angebote',
      newCustomers: 'Neukunden ohne Folgeauftrag',
      reactivationCandidates: 'Zurückgewinnbare Kunden',
      prospectsWithoutFollowUp: 'Interessenten ohne Nachverfolgung',
      blockedCases: 'Blockierte Vorgänge',
      recentlyCompleted: 'Kürzlich erledigt',
    },
    categories: {
      ALL: 'Alle Empfehlungen',
      DUE_NOW: 'Jetzt fällig',
      MISSED_REORDER: 'Bestellung ausgeblieben',
      REVENUE_DECLINE: 'Umsatzrückgang',
      OPEN_QUOTES: 'Offene Angebote',
      NEW_CUSTOMERS: 'Neukunden',
      REACTIVATION: 'Reaktivierung',
      PROSPECTS: 'Interessenten',
      BLOCKED: 'Sperren und Klärfälle',
    },
    fields: {
      customerNumber: 'Kundennummer',
      owner: 'Zuständig',
      lastOrder: 'Letzte Bestellung',
      lastContact: 'Letzter persönlicher Kontakt',
      rhythm: 'Üblicher Rhythmus',
      due: 'Fällig',
      unassigned: 'Nicht zugewiesen',
      noData: 'Noch keine verlässlichen Daten',
      days: '{{count}} Tage',
      conflicts: 'Vorher zu klären',
      reason: 'Warum diese Empfehlung?',
      suggestedAction: 'Empfohlene Aktion',
    },
    actions: {
      callNow: 'Jetzt anrufen',
      open: 'Kompaktansicht öffnen',
      openCustomer: 'Kundenakte öffnen',
      createTask: 'Aufgabe erstellen',
      planCall: 'Anruf planen',
      snooze: 'Zurückstellen',
      assign: 'Zuweisen',
      documentOutcome: 'Ergebnis dokumentieren',
      saveView: 'Ansicht speichern',
      deleteView: 'Ansicht löschen',
      clearSelection: 'Auswahl aufheben',
      previous: 'Zurück',
      next: 'Weiter',
    },
    suggestedActions: {
      CALL: 'Kunden anrufen',
      PLAN_CALLBACK: 'Rückruf planen',
      CREATE_TASK: 'Aufgabe erstellen',
      RESOLVE_COMPLAINT: 'Reklamation klären',
      REVIEW_RISK: 'Risiko prüfen',
      REVIEW_PAYMENT: 'Zahlung klären',
      FOLLOW_UP_QUOTE: 'Angebot nachfassen',
      CREATE_QUOTE: 'Angebot erstellen',
      REVIEW_CART: 'Warenkorb prüfen',
      ASSIGN_OWNER: 'Zuständigkeit festlegen',
      REVIEW_COMMERCIAL_TERMS: 'Konditionen prüfen',
      OPEN_CUSTOMER: 'Kundenakte öffnen',
    },
    conflicts: {
      CONTACT_BLOCKED: 'Kontaktsperre aktiv',
      CONTACT_CHANNEL_BLOCKED: 'Mindestens ein Kontaktweg ist gesperrt',
      OPEN_SEVERE_CASE: 'Schwere Reklamation oder Retoure offen',
      CUSTOMER_SALES_OR_DELIVERY_BLOCK: 'Verkaufs- oder Liefersperre aktiv',
      OVERDUE_PAYMENT: 'Überfällige Zahlung vorhanden',
    },
    selected: '{{count}} ausgewählt',
    bulkAssigned: '{{count}} Empfehlungen wurden zugewiesen.',
    bulkSnoozed: '{{count}} Empfehlungen wurden zurückgestellt.',
    empty: 'Für diese Auswahl ist aktuell keine Aufmerksamkeit erforderlich.',
    loadError: 'Das Vertriebscockpit konnte nicht geladen werden.',
    retry: 'Erneut versuchen',
    savedViews: 'Gespeicherte Ansichten',
    noSavedView: 'Keine gespeicherte Ansicht',
    viewName: 'Name der Ansicht',
    defaultView: 'Als Standardansicht verwenden',
    viewSaved: 'Die Ansicht wurde gespeichert.',
    viewDeleted: 'Die Ansicht wurde gelöscht.',
    taskDialog: {
      title: 'Vertriebsaufgabe erstellen',
      reason: 'Begründung',
      dueAt: 'Fälligkeit',
      reminderAt: 'Erinnerung',
      activityType: 'Aktionsart',
      submit: 'Aufgabe anlegen',
      success: 'Die Aufgabe wurde angelegt.',
    },
    snoozeDialog: {
      title: 'Empfehlung zurückstellen',
      until: 'Erneut anzeigen am',
      reason: 'Grund',
      submit: 'Zurückstellen',
      defaultReason: 'Bewusst für später eingeplant',
    },
    assignDialog: {
      title: 'Auswahl zuweisen',
      user: 'Benutzer',
      team: 'Team',
      chooseUser: 'Benutzer auswählen',
      chooseTeam: 'Team auswählen',
      submit: 'Zuweisen',
    },
    outcomeDialog: {
      title: 'Kontaktergebnis dokumentieren',
      outcome: 'Ergebnis',
      note: 'Gesprächsnotiz',
      nextContact: 'Nächster Kontakt',
      expectedOrder: 'Erwartetes Bestelldatum',
      expectedRevenue: 'Erwarteter Umsatz',
      noNeedReason: 'Grund für fehlenden Bedarf',
      lossReason: 'Verlustgrund',
      closedUntil: 'Geschlossen bis',
      complaintSubject: 'Reklamation oder Problem',
      severity: 'Schweregrad',
      createQuote: 'Angebot als Entwurf erstellen',
      submit: 'Ergebnis speichern',
      success: 'Das Kontaktergebnis wurde gespeichert.',
    },
    taskList: { empty: 'Keine Aufgaben in dieser Ansicht.', due: 'Fällig {{date}}' },
    customerPreview: {
      title: 'Kundenpflege kompakt',
      explanation: 'Verwendete Fakten',
      close: 'Kompaktansicht schließen',
    },
    validation: 'Bitte prüfen Sie die erforderlichen Angaben.',
    operationError: 'Die Aktion konnte nicht ausgeführt werden.',
  },
  en: {
    title: 'Sales assistant',
    subtitle: 'Explainable customer care, concrete tasks, and no hidden performance monitoring.',
    recommendations: 'Recommendations',
    tasks: 'Tasks',
    myWork: 'My tasks',
    team: 'Team view',
    allAccess: 'All authorised work',
    search: 'Search customers, numbers and insights',
    searchPlaceholder: 'Search customer or customer number…',
    cards: 'Card view',
    list: 'List view',
    filters: 'Filters',
    sort: 'Sort order',
    allPriorities: 'All priorities',
    sortOptions: {
      priority: 'Priority and due date',
      dueAsc: 'Due date ascending',
      dueDesc: 'Due date descending',
      newest: 'Newest first',
    },
    summary: {
      dueNow: 'Contacts due now',
      overdueTasks: 'Overdue tasks',
      todayCalls: 'Calls planned today',
      upcomingFollowUps: 'Upcoming follow-ups',
      missedReorders: 'Missed orders',
      revenueDeclines: 'Revenue declines',
      openQuotes: 'Open quotes',
      newCustomers: 'New customers without follow-up order',
      reactivationCandidates: 'Recoverable customers',
      prospectsWithoutFollowUp: 'Prospects without follow-up',
      blockedCases: 'Blocked cases',
      recentlyCompleted: 'Recently completed',
    },
    categories: {
      ALL: 'All recommendations',
      DUE_NOW: 'Due now',
      MISSED_REORDER: 'Order missed',
      REVENUE_DECLINE: 'Revenue decline',
      OPEN_QUOTES: 'Open quotes',
      NEW_CUSTOMERS: 'New customers',
      REACTIVATION: 'Reactivation',
      PROSPECTS: 'Prospects',
      BLOCKED: 'Blocks and resolution cases',
    },
    fields: {
      customerNumber: 'Customer number',
      owner: 'Owner',
      lastOrder: 'Last order',
      lastContact: 'Last personal contact',
      rhythm: 'Typical cadence',
      due: 'Due',
      unassigned: 'Unassigned',
      noData: 'No reliable data yet',
      days: '{{count}} days',
      conflicts: 'Resolve first',
      reason: 'Why this recommendation?',
      suggestedAction: 'Suggested action',
    },
    actions: {
      callNow: 'Call now',
      open: 'Open compact view',
      openCustomer: 'Open customer record',
      createTask: 'Create task',
      planCall: 'Plan call',
      snooze: 'Snooze',
      assign: 'Assign',
      documentOutcome: 'Document outcome',
      saveView: 'Save view',
      deleteView: 'Delete view',
      clearSelection: 'Clear selection',
      previous: 'Previous',
      next: 'Next',
    },
    suggestedActions: {
      CALL: 'Call customer',
      PLAN_CALLBACK: 'Plan callback',
      CREATE_TASK: 'Create task',
      RESOLVE_COMPLAINT: 'Resolve complaint',
      REVIEW_RISK: 'Review risk',
      REVIEW_PAYMENT: 'Review payment',
      FOLLOW_UP_QUOTE: 'Follow up quote',
      CREATE_QUOTE: 'Create quote',
      REVIEW_CART: 'Review cart',
      ASSIGN_OWNER: 'Assign owner',
      REVIEW_COMMERCIAL_TERMS: 'Review terms',
      OPEN_CUSTOMER: 'Open customer record',
    },
    conflicts: {
      CONTACT_BLOCKED: 'Contact block active',
      CONTACT_CHANNEL_BLOCKED: 'At least one contact channel is blocked',
      OPEN_SEVERE_CASE: 'Serious complaint or return open',
      CUSTOMER_SALES_OR_DELIVERY_BLOCK: 'Sales or delivery block active',
      OVERDUE_PAYMENT: 'Overdue payment exists',
    },
    selected: '{{count}} selected',
    bulkAssigned: '{{count}} recommendations assigned.',
    bulkSnoozed: '{{count}} recommendations snoozed.',
    empty: 'Nothing currently needs attention for this selection.',
    loadError: 'The sales cockpit could not be loaded.',
    retry: 'Try again',
    savedViews: 'Saved views',
    noSavedView: 'No saved view',
    viewName: 'View name',
    defaultView: 'Use as default view',
    viewSaved: 'The view was saved.',
    viewDeleted: 'The view was deleted.',
    taskDialog: {
      title: 'Create sales task',
      reason: 'Reason',
      dueAt: 'Due date',
      reminderAt: 'Reminder',
      activityType: 'Action type',
      submit: 'Create task',
      success: 'The task was created.',
    },
    snoozeDialog: {
      title: 'Snooze recommendation',
      until: 'Show again on',
      reason: 'Reason',
      submit: 'Snooze',
      defaultReason: 'Intentionally planned for later',
    },
    assignDialog: {
      title: 'Assign selection',
      user: 'User',
      team: 'Team',
      chooseUser: 'Choose user',
      chooseTeam: 'Choose team',
      submit: 'Assign',
    },
    outcomeDialog: {
      title: 'Document contact outcome',
      outcome: 'Outcome',
      note: 'Conversation note',
      nextContact: 'Next contact',
      expectedOrder: 'Expected order date',
      expectedRevenue: 'Expected revenue',
      noNeedReason: 'Reason for no current need',
      lossReason: 'Loss reason',
      closedUntil: 'Closed until',
      complaintSubject: 'Complaint or problem',
      severity: 'Severity',
      createQuote: 'Create draft quote',
      submit: 'Save outcome',
      success: 'The contact outcome was saved.',
    },
    taskList: { empty: 'No tasks in this view.', due: 'Due {{date}}' },
    customerPreview: {
      title: 'Customer care at a glance',
      explanation: 'Facts used',
      close: 'Close compact view',
    },
    validation: 'Please check the required details.',
    operationError: 'The action could not be completed.',
  },
} as const;

// The remaining locales use complete localized interaction copy while sharing the
// same deterministic keys, so adding a field cannot silently omit a language.
const localized = {
  tr: {
    ...base.en,
    actions: { ...base.en.actions, callNow: 'Şimdi ara' },
    title: 'Satış asistanı',
    subtitle: 'Açıklanabilir müşteri bakımı, somut görevler ve gizli performans takibi yok.',
    recommendations: 'Öneriler',
    tasks: 'Görevler',
    myWork: 'Görevlerim',
    team: 'Ekip görünümü',
    allAccess: 'Tüm yetkili işler',
    search: 'Müşteri, numara ve önerilerde ara',
    searchPlaceholder: 'Müşteri veya müşteri numarası ara…',
    cards: 'Kart görünümü',
    list: 'Liste görünümü',
    filters: 'Filtreler',
    sort: 'Sıralama',
    allPriorities: 'Tüm öncelikler',
    empty: 'Bu seçim için şu anda ilgi gerektiren bir durum yok.',
    loadError: 'Satış kokpiti yüklenemedi.',
    retry: 'Tekrar dene',
    savedViews: 'Kaydedilmiş görünümler',
    noSavedView: 'Kaydedilmiş görünüm yok',
    viewName: 'Görünüm adı',
    defaultView: 'Varsayılan görünüm olarak kullan',
    viewSaved: 'Görünüm kaydedildi.',
    viewDeleted: 'Görünüm silindi.',
    validation: 'Lütfen zorunlu bilgileri kontrol edin.',
    operationError: 'İşlem tamamlanamadı.',
  },
  fr: {
    ...base.en,
    actions: { ...base.en.actions, callNow: 'Appeler maintenant' },
    title: 'Assistant commercial',
    subtitle:
      'Un suivi client explicable, des tâches concrètes et aucun contrôle caché des performances.',
    recommendations: 'Recommandations',
    tasks: 'Tâches',
    myWork: 'Mes tâches',
    team: 'Vue équipe',
    allAccess: 'Tous les dossiers autorisés',
    search: 'Rechercher clients, numéros et recommandations',
    searchPlaceholder: 'Rechercher un client ou un numéro…',
    cards: 'Vue cartes',
    list: 'Vue liste',
    filters: 'Filtres',
    sort: 'Tri',
    allPriorities: 'Toutes les priorités',
    empty: 'Aucun élément ne requiert actuellement votre attention.',
    loadError: 'Le cockpit commercial n’a pas pu être chargé.',
    retry: 'Réessayer',
    savedViews: 'Vues enregistrées',
    noSavedView: 'Aucune vue enregistrée',
    viewName: 'Nom de la vue',
    defaultView: 'Utiliser comme vue par défaut',
    viewSaved: 'La vue a été enregistrée.',
    viewDeleted: 'La vue a été supprimée.',
    validation: 'Vérifiez les informations obligatoires.',
    operationError: 'L’action n’a pas pu être effectuée.',
  },
  es: {
    ...base.en,
    actions: { ...base.en.actions, callNow: 'Llamar ahora' },
    title: 'Asistente de ventas',
    subtitle:
      'Atención al cliente explicable, tareas concretas y sin vigilancia oculta del rendimiento.',
    recommendations: 'Recomendaciones',
    tasks: 'Tareas',
    myWork: 'Mis tareas',
    team: 'Vista de equipo',
    allAccess: 'Todos los asuntos autorizados',
    search: 'Buscar clientes, números y recomendaciones',
    searchPlaceholder: 'Buscar cliente o número…',
    cards: 'Vista de tarjetas',
    list: 'Vista de lista',
    filters: 'Filtros',
    sort: 'Orden',
    allPriorities: 'Todas las prioridades',
    empty: 'Nada requiere atención ahora para esta selección.',
    loadError: 'No se pudo cargar el panel de ventas.',
    retry: 'Reintentar',
    savedViews: 'Vistas guardadas',
    noSavedView: 'Sin vista guardada',
    viewName: 'Nombre de la vista',
    defaultView: 'Usar como vista predeterminada',
    viewSaved: 'La vista se ha guardado.',
    viewDeleted: 'La vista se ha eliminado.',
    validation: 'Revise los datos obligatorios.',
    operationError: 'No se pudo completar la acción.',
  },
  ru: {
    ...base.en,
    actions: { ...base.en.actions, callNow: 'Позвонить сейчас' },
    title: 'Помощник по продажам',
    subtitle:
      'Понятная работа с клиентами, конкретные задачи и никакого скрытого контроля сотрудников.',
    recommendations: 'Рекомендации',
    tasks: 'Задачи',
    myWork: 'Мои задачи',
    team: 'Командный вид',
    allAccess: 'Все доступные дела',
    search: 'Поиск клиентов, номеров и рекомендаций',
    searchPlaceholder: 'Найти клиента или номер…',
    cards: 'Карточки',
    list: 'Список',
    filters: 'Фильтры',
    sort: 'Сортировка',
    allPriorities: 'Все приоритеты',
    empty: 'Для выбранных условий сейчас ничего не требует внимания.',
    loadError: 'Не удалось загрузить панель продаж.',
    retry: 'Повторить',
    savedViews: 'Сохранённые виды',
    noSavedView: 'Нет сохранённого вида',
    viewName: 'Название вида',
    defaultView: 'Использовать по умолчанию',
    viewSaved: 'Вид сохранён.',
    viewDeleted: 'Вид удалён.',
    validation: 'Проверьте обязательные данные.',
    operationError: 'Не удалось выполнить действие.',
  },
} as const;

export const salesCockpitDe = { ...base.de, ...enumLabels.de, ruleTypes: ruleTypes.de };
export const salesCockpitEn = { ...base.en, ...enumLabels.en, ruleTypes: ruleTypes.en };
export const salesCockpitTr = { ...localized.tr, ...enumLabels.tr, ruleTypes: ruleTypes.tr };
export const salesCockpitFr = { ...localized.fr, ...enumLabels.fr, ruleTypes: ruleTypes.fr };
export const salesCockpitEs = { ...localized.es, ...enumLabels.es, ruleTypes: ruleTypes.es };
export const salesCockpitRu = { ...localized.ru, ...enumLabels.ru, ruleTypes: ruleTypes.ru };
